// Queries
import allUnits from "./AllUnitsQuery.gql";

export const Query = {
    allUnits,
};
